import React from 'react';
import { Typography } from '@material-ui/core';
import {
  IoIosCheckmarkCircleOutline,
  IoIosCloseCircleOutline,
} from 'react-icons/io';
import { useStyles } from './styles';

interface ICreateOrderPopup {
  region: string;
  road: string;
  onClose: any;
  onConfirm: any;
}

const CreateOrderPopup: React.FC<ICreateOrderPopup> = ({
  region,
  road,
  onClose,
  onConfirm,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.labelContainer}>
        <Typography variant="subtitle1" className={classes.label}>
          {road === '-' ? `${region}` : `Pista ${road} - ${region}`}
        </Typography>
      </div>
      <div className={classes.buttonsContainer}>
        <button type="button" onClick={onClose} className={classes.button}>
          <IoIosCloseCircleOutline size={24} color="#E55353" />
        </button>
        <button
          type="button"
          onClick={onConfirm}
          className={classes.button}
          style={{ marginLeft: 8 }}
        >
          <IoIosCheckmarkCircleOutline size={24} color="#2EB85C" />
        </button>
      </div>
    </div>
  );
};

export default CreateOrderPopup;
